import React, { useState } from 'react'
import NotificationCard from '../../components/NotificationCard/NotificationCard';

function SubAdminNotification() {
    const [notifications, setNotifications] = useState([
        {
            id: 25,
            heading: "You have a new order",
            message: "New order placed with ID ORD129489544903",
            created_at: "2025-03-04T12:22:57.294150+05:30",
            is_read: false,
        },
        {
            id: 26,
            heading: "Payment Received",
            message: "Payment of ₹1,500 received for order ORD129489544903",
            created_at: "2025-03-04T13:10:45.123450+05:30",
            is_read: false,
        },
        {
            id: 27,
            heading: "Order Dispatched",
            message: "Your order ORD129489544903 has been dispatched",
            created_at: "2025-03-04T14:30:12.987650+05:30",
            is_read: true,
        },
        {
            id: 28,
            heading: "New User Signup",
            message: "A new user has registered with the email example@example.com",
            created_at: "2025-03-04T15:05:32.456320+05:30",
            is_read: false,
        },
        {
            id: 29,
            heading: "Stock Alert",
            message: "Item SKU1234 is running low on stock",
            created_at: "2025-03-04T16:40:18.785690+05:30",
            is_read: true,
        },
        {
            id: 30,
            heading: "Refund Processed",
            message: "Refund of ₹500 processed for order ORD123456789",
            created_at: "2025-03-04T17:25:45.369120+05:30",
            is_read: false,
        },
        {
            id: 31,
            heading: "New Review Received",
            message: "You received a 5-star review for product XYZ",
            created_at: "2025-03-04T18:10:20.542670+05:30",
            is_read: false,
        },
        {
            id: 32,
            heading: "Security Alert",
            message: "Suspicious login attempt detected from a new device",
            created_at: "2025-03-04T19:00:00.987120+05:30",
            is_read: true,
        },
    ]);


    return (
        <div>
            <NotificationCard notifications={notifications} />
        </div>
    );
}

export default SubAdminNotification